if (!customElements.get('dobranoc-home-product')) {
  customElements.define(
    'dobranoc-home-product',
    class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.addEventListener(
          'change',
          (event) => {
            if (event.target.matches('[data-db-home-product-variant]')) this.updateVariant();
          },
          { signal: this.abortController.signal }
        );
        this.updateVariant();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      updateVariant() {
        const variant = this.querySelector('[data-db-home-product-variant]:checked');
        if (!variant) return;

        const price = this.querySelector('[data-db-home-product-price]');
        const addButton = this.querySelector('[data-db-home-product-add]');
        const detailLink = this.querySelector('[data-db-home-product-detail]');
        const available = variant.dataset.available === 'true';

        if (price) price.textContent = variant.dataset.price;
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? this.dataset.addLabel : this.dataset.unavailableLabel;
        }
        if (detailLink) {
          const url = new URL(detailLink.href, window.location.origin);
          url.searchParams.set('variant', variant.value);
          detailLink.href = url.href;
        }
      }
    }
  );
}
